import { render, staticRenderFns } from "./BaseCalendarView.vue?vue&type=template&id=d2db971e&"
import script from "./BaseCalendarView.vue?vue&type=script&lang=ts&"
export * from "./BaseCalendarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports